import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IAgentSendPasswordResetEmailClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentSendPasswordResetEmailClient';
import { getCookie } from 'utils/cookie';
const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/user/send_password_reset_email`;

export class AgentSendPasswordResetEmailClient implements IAgentSendPasswordResetEmailClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { email } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };
        const body = JSON.stringify({ email });
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
